import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

import { useToast } from '@/libraries/vue-toast';
import { useRoleActionAccess } from '@/composition/useRoleActionAccess';
import { useWSChannelSubscribe } from '@/composition/useWebsocket';
import { launcherChannel, sessionChannel } from '@/services/websocket';
import { paths } from '@/constants/routes';
import { killStorageItem } from '@/utils';
import { setBuilderLocales } from '@/router/Admin/builderManuals';

import Header from '@/components/Header/index.vue';
import Footer from '@/components/Footer.vue';
import BaseSpinner from '@/components/base/BaseSpinner.vue';
import { version } from '../package.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const { role } = useRoleActionAccess();

const toast = useToast();
const store = useStore();
const router = useRouter();
const route = useRoute();

const isSuAccessRole = computed(() => store.getters.isSuAccessRole);
const showLoader = computed(() => store.getters['Common/showLoader']);

const resetPaymentQuery = () => {
  const query = { ...route.query };
  delete query.payment;
  router.replace({ query });
};

if (window.location.href.includes('payment=success')) {
  killStorageItem('basket');

  toast.open({
    message: t('paymentSuccess'),
    type: 'success',
    position: 'bottom-right',
  });
  resetPaymentQuery();
}

const clearUserData = () => {
  if (store.getters.isLoggingOut) { return; }
  store.dispatch('clearUserData');
  router.push(paths.alerts.sessionClosed);
};

if (role.value) {
  const wsSubscribe = useWSChannelSubscribe(sessionChannel.value);
  wsSubscribe?.on('publication', ({ data }) => {
    if (data?.event === 'closed') {
      clearUserData();
    }
  });
}

if (isSuAccessRole.value) {
  const wsSubscribeLauncher = useWSChannelSubscribe(launcherChannel.value);
  wsSubscribeLauncher?.on('publication', ({ data }: { data: any }) => {
    if (data?.event === 'product.publication.end') {
      store.commit('Common/SET_WS_LAUNCHER', data);
    }
  });
}

store.dispatch('Locales/getSupportedLocales');
store.dispatch('Locales/getRequiredLocales');

const supportedLocales = computed(() => store.getters['Locales/supportedLocales']);
setBuilderLocales(supportedLocales.value);

console.log(`v ${version}`);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(_component_router_view),
    _createVNode(Footer),
    _withDirectives(_createVNode(BaseSpinner, null, null, 512), [
      [_vShow, showLoader.value]
    ])
  ], 64))
}
}

})